export default "__VITE_ASSET__yxeR6tm8__"